import ImportarCuadranteModal from "../modals/ImportarCuadranteModal";
import CalendariosModal from "../modals/CalendariosModal";
import CierreJornadaModal from "../modals/CierreJornadaModal";
import ImportCuadernoModal from "../modals/ImportCuadernoModal";
import { equipoPrincipal, esSuper } from "../../utils";

// Los modales que traen su propio marco (importar cuadrantes, calendarios, cierre
// de jornada, importar el cuaderno): App no los envuelve en su caja de modal.

export default function ModalesSinMarco({ modal, setModal, users, teams, currentUser, calendarios, createCalendario, updateCalendario, deleteCalendario, importarCalendario, duplicarAnio, importarGuardias, importarVacaciones, agendaTiposData, crono, loadAgenda, recargarPasos, setAgenda, showToast }) {
  return (
    <>
      {modal==="importarGuardias"&&(
        <ImportarCuadranteModal
          titulo="Importar cuadrante de guardias" users={users}
          ayuda="Una línea por semana, con una fecha y el nombre de la persona. La fecha se lleva al lunes de su semana, así que sirve cualquier día de esa semana. Separa los campos con punto y coma, tabulador o dos espacios — pegando dos columnas de Excel funciona directamente."
          ejemplo={["05/01/2026;anton", "12/01/2026;adrian", "19/01/2026;toni"]}
          onComprobar={(t,m)=>importarGuardias(t,m,true)}
          onConfirmar={async(t,m)=>{ await importarGuardias(t,m,false); setModal(null); }}
          resumenPrevia={r=>`${r.semanas} semana(s) reconocida(s)`}
          onClose={()=>setModal(null)}/>
      )}
      {modal==="importarVacaciones"&&(
        <ImportarCuadranteModal
          titulo="Importar periodos de vacaciones" users={users}
          ayuda="Una línea por periodo: nombre y una o dos fechas (inicio y fin). Con una sola fecha se entiende un día suelto. Puedes añadir un campo final con el tipo: permiso o baja. Los periodos idénticos que ya existan se omiten, así que puedes reimportar sin duplicar."
          ejemplo={["alex;10/08/2026;28/08/2026", "hugo;20/07/2026;31/07/2026", "adri;11/12/2026;11/12/2026;permiso"]}
          onComprobar={(t,m)=>importarVacaciones(t,m,true)}
          onConfirmar={async(t,m)=>{ await importarVacaciones(t,m,false); setModal(null); }}
          resumenPrevia={r=>`${r.periodos} periodo(s) reconocido(s)`}
          onClose={()=>setModal(null)}/>
      )}
      {modal==="calendarios"&&(
        <CalendariosModal
          calendarios={calendarios} isAdmin={esSuper(currentUser)}
          onCreate={createCalendario} onUpdate={updateCalendario} onDelete={deleteCalendario}
          onImportar={importarCalendario} onDuplicarAnio={duplicarAnio}
          onClose={()=>setModal(null)}/>
      )}
      {modal==="cierreJornada"&&(
        <CierreJornadaModal
          agendaTiposData={agendaTiposData} guardando={crono.guardando}
          onConfirmar={async tareas=>{
            const r = await crono.cerrarJornada(tareas);
            if (!r) return;                 // fallo: el modal se queda abierto
            setModal(null);
            loadAgenda();                   // el cuaderno ya tiene las entradas
            // Cerrar un paso DESBLOQUEA a sus sucesores: el buscador tiene que
            // reflejarlo sin recargar la pagina.
            recargarPasos();
          }}
          onDespues={()=>{crono.setPendienteCierre(true);setModal(null);}}/>
      )}
      {modal?.type==="importCuaderno"&&(
        <ImportCuadernoModal onClose={()=>setModal(null)} defaultDepartment={equipoPrincipal(currentUser, teams)} onImported={newEntries=>{setAgenda(prev=>[...newEntries,...prev]);showToast(`${newEntries.length} entradas importadas`);}}/>
      )}
    </>
  );
}
